import { useEffect, useState } from "react";

// Cache in-memory + fetch singola degli asset del sito gestiti da admin.
// Ritorna { assets, get(key) }. Se non configurato, get() torna null e il
// componente usa il proprio default.
let _cache = null;
let _inflight = null;

export function useSiteAssets() {
  const [assets, setAssets] = useState(_cache || {});

  useEffect(() => {
    if (_cache) {
      setAssets(_cache);
      return;
    }
    const base = process.env.REACT_APP_BACKEND_URL || "";
    if (!_inflight) {
      _inflight = fetch(`${base}/api/site-assets`)
        .then((r) => r.json())
        .then((d) => {
          _cache = d.assets || {};
          return _cache;
        })
        .catch(() => {
          _cache = {};
          return _cache;
        });
    }
    let alive = true;
    _inflight.then((a) => alive && setAssets(a));
    return () => {
      alive = false;
    };
  }, []);

  const get = (key) => (assets && assets[key] && assets[key].url ? assets[key] : null);
  return { assets, get };
}
